import React from 'react'
import { Link } from 'gatsby'
import { getThree, orderbyFeatured, orderbyDate } from '@helpers/helper.novelty'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'

const Novelties_1 = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const {
    title,
    subtitle,
    titleElement,
    subtitleElement,
    button,
    backgroundColor,
    backgroundHexa,
    darkMode
  } = props
  const { id: siteId } = global_data
  const noveltyCard = global_data.content?.cardsNovelties?.type_id ?? '1'
  const { data: allBlogData, isLoading, isError } = useGetBlogsQuery({ site: siteId })

  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  return (
    <section
      style={{ backgroundColor: backgroundColor === 'background-picker' ? backgroundHexa : '' }}
      className={
        'novelties-home a py-5 ' +
        ((isError || allBlogData?.news?.length === 0) && 'd-none') +
        ' ' +
        backgroundColor
      }
    >
      <div className="opacity"></div>
      <div className="container-fluid py-lg-5">
        <div className="row">
          <div className="col-12 col-lg-2">
            <ElementHTML
              children={title!}
              elementType={titleElement || 'p'}
              className={`section-name ${darkMode ? 'text-tertiary' : ''}`}
            />
          </div>
          {subtitle && (
            <div className="col-12 col-lg-10">
              <ElementHTML
                children={subtitle!}
                elementType={subtitleElement || 'h2'}
                className={`sub-section mb-lg-4 mb-3 ${darkMode ? 'text-tertiary' : ''}`}
              />
            </div>
          )}

          <div
            className={'col-12 col-lg-10 offset-0  ' + (subtitle ? ' mt-lg-4 offset-lg-2 ' : '')}
          >
            <div className={'row ' + (subtitle ? 'py-lg-5' : '')}>
              {isLoading
                ? [1, 2, 3].map((index) => (
                    <div
                      className="mb-4 mb-lg-0 col-12 col-lg-4"
                      key={index}
                    >
                      <div className="me-3 d-inline">
                        <Card
                          isHome={true}
                          skeleton={true}
                          global_data={global_data}
                        />
                      </div>
                    </div>
                  ))
                : allBlogData &&
                  getThree(orderbyFeatured(orderbyDate(allBlogData.news)))?.map(
                    (novelty, index) => (
                      <div
                        className="mb-4 mb-lg-0 col-12 col-lg-4"
                        key={index}
                      >
                        <Card
                          isHome={true}
                          novelty={novelty}
                          hidenTags={true}
                          hidenAuthor={true}
                          global_data={global_data}
                        />
                      </div>
                    ),
                  )}
            </div>
          </div>
          {button && (
            <div className="col-12 col-lg-10 mt-5 offset-lg-2 text-start">
              <Link
                to={button.link}
                className={`btn ${darkMode ? 'btn-white' : 'btn-red'}`}
              >
                {button.value}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Novelties_1
